import React from 'react';
import { requiredAuth } from '../auth';

const EmptyComponent: React.FC = () => {
    return <style className="auth" dangerouslySetInnerHTML={{ __html: `* { display:none; }` }} />;
};

const AuthComponent = requiredAuth(EmptyComponent);

export const Auth: React.FC = () => {
    return <AuthComponent />;
};
